module.exports = __webpack_public_path__ + "img/chave_pix.901ac651.jpg";